<div class="cpjWrapper">
    <div class="cpj-header">
        <span class="cpj-title">{{ 'Home.cpj' | translate }}</span>
    </div>

    <div class="entries">
        <p class="featured-title">{{ 'Home.featuredarticle' | translate }}</p>

        <h3 class="entry-title">Measles: A resurgent threat and the role of pharmacists in prevention</h3>
        <p>
            Considered eliminated in Canada over 25 years ago, measles has re-emerged as a public health concern due to 
            declining vaccination rates and increased global travel. In fact, recently Canada, and by extension all the Americas, 
            has been stripped of its measles-free certification by the Pan American Health Organization (PAHO) after failing to curb an 
            outbreak of the virus for 12 consecutive months.
        </p>

        <p class="readmore"><a href="https://utppublishing.com/doi/10.3138/cpj-25-0104">{{ 'Home.readmore' | translate }}</a></p>
    </div>
</div>